// source: xcommon/module.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_enum_pb = require('../xcommon/enum_pb.js');
goog.object.extend(proto, xcommon_enum_pb);
var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
goog.exportSymbol('proto.xcommon.Extension', null, global);
goog.exportSymbol('proto.xcommon.GetByUserIDReq', null, global);
goog.exportSymbol('proto.xcommon.MarkMeta', null, global);
goog.exportSymbol('proto.xcommon.Meta', null, global);
goog.exportSymbol('proto.xcommon.ResourceInfo', null, global);
goog.exportSymbol('proto.xcommon.ResourcePermInfo', null, global);
goog.exportSymbol('proto.xcommon.TreeNode', null, global);
goog.exportSymbol('proto.xcommon.TreeResp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.GetByUserIDReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.GetByUserIDReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.GetByUserIDReq.displayName = 'proto.xcommon.GetByUserIDReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Meta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.Meta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Meta.displayName = 'proto.xcommon.Meta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MarkMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MarkMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MarkMeta.displayName = 'proto.xcommon.MarkMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.Extension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.Extension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.Extension.displayName = 'proto.xcommon.Extension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TreeNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TreeNode.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TreeNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TreeNode.displayName = 'proto.xcommon.TreeNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.TreeResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.TreeResp.repeatedFields_, null);
};
goog.inherits(proto.xcommon.TreeResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.TreeResp.displayName = 'proto.xcommon.TreeResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ResourceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ResourceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ResourceInfo.displayName = 'proto.xcommon.ResourceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ResourcePermInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ResourcePermInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ResourcePermInfo.displayName = 'proto.xcommon.ResourcePermInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.GetByUserIDReq.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.GetByUserIDReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.GetByUserIDReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetByUserIDReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.GetByUserIDReq}
 */
proto.xcommon.GetByUserIDReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.GetByUserIDReq;
  return proto.xcommon.GetByUserIDReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.GetByUserIDReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.GetByUserIDReq}
 */
proto.xcommon.GetByUserIDReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.GetByUserIDReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.GetByUserIDReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.GetByUserIDReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.GetByUserIDReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.xcommon.GetByUserIDReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.xcommon.GetByUserIDReq} returns this
*/
proto.xcommon.GetByUserIDReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.GetByUserIDReq} returns this
 */
proto.xcommon.GetByUserIDReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.GetByUserIDReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 UserId = 2;
 * @return {number}
 */
proto.xcommon.GetByUserIDReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.GetByUserIDReq} returns this
 */
proto.xcommon.GetByUserIDReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Meta.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Meta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Meta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Meta.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Meta}
 */
proto.xcommon.Meta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Meta;
  return proto.xcommon.Meta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Meta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Meta}
 */
proto.xcommon.Meta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Meta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Meta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Meta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Meta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.Meta.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.Meta} returns this
 */
proto.xcommon.Meta.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.Meta.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.Meta} returns this
 */
proto.xcommon.Meta.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MarkMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MarkMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MarkMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarkMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mark: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MarkMeta}
 */
proto.xcommon.MarkMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MarkMeta;
  return proto.xcommon.MarkMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MarkMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MarkMeta}
 */
proto.xcommon.MarkMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.Mark} */ (reader.readEnum());
      msg.setMark(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MarkMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MarkMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MarkMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarkMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMark();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.MarkMeta.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.MarkMeta} returns this
 */
proto.xcommon.MarkMeta.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.MarkMeta.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.MarkMeta} returns this
 */
proto.xcommon.MarkMeta.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Mark Mark = 3;
 * @return {!proto.xcommon.Mark}
 */
proto.xcommon.MarkMeta.prototype.getMark = function() {
  return /** @type {!proto.xcommon.Mark} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.Mark} value
 * @return {!proto.xcommon.MarkMeta} returns this
 */
proto.xcommon.MarkMeta.prototype.setMark = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.Extension.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.Extension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.Extension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Extension.toObject = function(includeInstance, msg) {
  var f, obj = {
    exectype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    operator: jspb.Message.getFieldWithDefault(msg, 2, ""),
    operatortime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    permtype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    menuid: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.Extension}
 */
proto.xcommon.Extension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.Extension;
  return proto.xcommon.Extension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.Extension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.Extension}
 */
proto.xcommon.Extension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.ExecType} */ (reader.readEnum());
      msg.setExectype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOperatortime(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.PermType} */ (reader.readEnum());
      msg.setPermtype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMenuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.Extension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.Extension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.Extension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.Extension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExectype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOperatortime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPermtype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getMenuid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional ExecType ExecType = 1;
 * @return {!proto.xcommon.ExecType}
 */
proto.xcommon.Extension.prototype.getExectype = function() {
  return /** @type {!proto.xcommon.ExecType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.xcommon.ExecType} value
 * @return {!proto.xcommon.Extension} returns this
 */
proto.xcommon.Extension.prototype.setExectype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Operator = 2;
 * @return {string}
 */
proto.xcommon.Extension.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.Extension} returns this
 */
proto.xcommon.Extension.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 OperatorTime = 3;
 * @return {number}
 */
proto.xcommon.Extension.prototype.getOperatortime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.Extension} returns this
 */
proto.xcommon.Extension.prototype.setOperatortime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional PermType PermType = 4;
 * @return {!proto.xcommon.PermType}
 */
proto.xcommon.Extension.prototype.getPermtype = function() {
  return /** @type {!proto.xcommon.PermType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.xcommon.PermType} value
 * @return {!proto.xcommon.Extension} returns this
 */
proto.xcommon.Extension.prototype.setPermtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 MenuId = 5;
 * @return {number}
 */
proto.xcommon.Extension.prototype.getMenuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.Extension} returns this
 */
proto.xcommon.Extension.prototype.setMenuid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TreeNode.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TreeNode.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TreeNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TreeNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TreeNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mark: jspb.Message.getFieldWithDefault(msg, 4, 0),
    ext: (f = msg.getExt()) && proto.xcommon.Extension.toObject(includeInstance, f),
    kidsList: jspb.Message.toObjectList(msg.getKidsList(),
    proto.xcommon.TreeNode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TreeNode}
 */
proto.xcommon.TreeNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TreeNode;
  return proto.xcommon.TreeNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TreeNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TreeNode}
 */
proto.xcommon.TreeNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.xcommon.Mark} */ (reader.readEnum());
      msg.setMark(value);
      break;
    case 5:
      var value = new proto.xcommon.Extension;
      reader.readMessage(value,proto.xcommon.Extension.deserializeBinaryFromReader);
      msg.setExt(value);
      break;
    case 6:
      var value = new proto.xcommon.TreeNode;
      reader.readMessage(value,proto.xcommon.TreeNode.deserializeBinaryFromReader);
      msg.addKids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TreeNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TreeNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TreeNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TreeNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getPid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMark();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getExt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.Extension.serializeBinaryToWriter
    );
  }
  f = message.getKidsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.xcommon.TreeNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.TreeNode.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.TreeNode} returns this
 */
proto.xcommon.TreeNode.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 Pid = 2;
 * @return {number}
 */
proto.xcommon.TreeNode.prototype.getPid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.TreeNode} returns this
 */
proto.xcommon.TreeNode.prototype.setPid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.TreeNode.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.TreeNode} returns this
 */
proto.xcommon.TreeNode.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Mark Mark = 4;
 * @return {!proto.xcommon.Mark}
 */
proto.xcommon.TreeNode.prototype.getMark = function() {
  return /** @type {!proto.xcommon.Mark} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.xcommon.Mark} value
 * @return {!proto.xcommon.TreeNode} returns this
 */
proto.xcommon.TreeNode.prototype.setMark = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Extension Ext = 5;
 * @return {?proto.xcommon.Extension}
 */
proto.xcommon.TreeNode.prototype.getExt = function() {
  return /** @type{?proto.xcommon.Extension} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.Extension, 5));
};


/**
 * @param {?proto.xcommon.Extension|undefined} value
 * @return {!proto.xcommon.TreeNode} returns this
*/
proto.xcommon.TreeNode.prototype.setExt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.TreeNode} returns this
 */
proto.xcommon.TreeNode.prototype.clearExt = function() {
  return this.setExt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.TreeNode.prototype.hasExt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated TreeNode Kids = 6;
 * @return {!Array<!proto.xcommon.TreeNode>}
 */
proto.xcommon.TreeNode.prototype.getKidsList = function() {
  return /** @type{!Array<!proto.xcommon.TreeNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TreeNode, 6));
};


/**
 * @param {!Array<!proto.xcommon.TreeNode>} value
 * @return {!proto.xcommon.TreeNode} returns this
*/
proto.xcommon.TreeNode.prototype.setKidsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.xcommon.TreeNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TreeNode}
 */
proto.xcommon.TreeNode.prototype.addKids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.xcommon.TreeNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.TreeNode} returns this
 */
proto.xcommon.TreeNode.prototype.clearKidsList = function() {
  return this.setKidsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.TreeResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.TreeResp.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.TreeResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.TreeResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TreeResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    treeList: jspb.Message.toObjectList(msg.getTreeList(),
    proto.xcommon.TreeNode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.TreeResp}
 */
proto.xcommon.TreeResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.TreeResp;
  return proto.xcommon.TreeResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.TreeResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.TreeResp}
 */
proto.xcommon.TreeResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.xcommon.TreeNode;
      reader.readMessage(value,proto.xcommon.TreeNode.deserializeBinaryFromReader);
      msg.addTree(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.TreeResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.TreeResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.TreeResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.TreeResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getTreeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.TreeNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.xcommon.TreeResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.xcommon.TreeResp} returns this
*/
proto.xcommon.TreeResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.xcommon.TreeResp} returns this
 */
proto.xcommon.TreeResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.TreeResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TreeNode Tree = 2;
 * @return {!Array<!proto.xcommon.TreeNode>}
 */
proto.xcommon.TreeResp.prototype.getTreeList = function() {
  return /** @type{!Array<!proto.xcommon.TreeNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.TreeNode, 2));
};


/**
 * @param {!Array<!proto.xcommon.TreeNode>} value
 * @return {!proto.xcommon.TreeResp} returns this
*/
proto.xcommon.TreeResp.prototype.setTreeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.TreeNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.TreeNode}
 */
proto.xcommon.TreeResp.prototype.addTree = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.TreeNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.xcommon.TreeResp} returns this
 */
proto.xcommon.TreeResp.prototype.clearTreeList = function() {
  return this.setTreeList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ResourceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ResourceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ResourceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ResourceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFieldWithDefault(msg, 3, ""),
    operator: jspb.Message.getFieldWithDefault(msg, 4, ""),
    operatortime: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ResourceInfo}
 */
proto.xcommon.ResourceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ResourceInfo;
  return proto.xcommon.ResourceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ResourceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ResourceInfo}
 */
proto.xcommon.ResourceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOperatortime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ResourceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ResourceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ResourceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ResourceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOperatortime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.ResourceInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ResourceInfo} returns this
 */
proto.xcommon.ResourceInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.ResourceInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ResourceInfo} returns this
 */
proto.xcommon.ResourceInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Value = 3;
 * @return {string}
 */
proto.xcommon.ResourceInfo.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ResourceInfo} returns this
 */
proto.xcommon.ResourceInfo.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Operator = 4;
 * @return {string}
 */
proto.xcommon.ResourceInfo.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ResourceInfo} returns this
 */
proto.xcommon.ResourceInfo.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 OperatorTime = 5;
 * @return {number}
 */
proto.xcommon.ResourceInfo.prototype.getOperatortime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ResourceInfo} returns this
 */
proto.xcommon.ResourceInfo.prototype.setOperatortime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ResourcePermInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ResourcePermInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ResourcePermInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ResourcePermInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    permid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    permname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    value: jspb.Message.getFieldWithDefault(msg, 5, ""),
    operator: jspb.Message.getFieldWithDefault(msg, 6, ""),
    operatortime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    bindingid: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ResourcePermInfo}
 */
proto.xcommon.ResourcePermInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ResourcePermInfo;
  return proto.xcommon.ResourcePermInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ResourcePermInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ResourcePermInfo}
 */
proto.xcommon.ResourcePermInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPermid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPermname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperator(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOperatortime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBindingid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ResourcePermInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ResourcePermInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ResourcePermInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ResourcePermInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPermid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPermname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOperator();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOperatortime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getBindingid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.ResourcePermInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ResourcePermInfo} returns this
 */
proto.xcommon.ResourcePermInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.ResourcePermInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ResourcePermInfo} returns this
 */
proto.xcommon.ResourcePermInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 PermId = 3;
 * @return {number}
 */
proto.xcommon.ResourcePermInfo.prototype.getPermid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ResourcePermInfo} returns this
 */
proto.xcommon.ResourcePermInfo.prototype.setPermid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string PermName = 4;
 * @return {string}
 */
proto.xcommon.ResourcePermInfo.prototype.getPermname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ResourcePermInfo} returns this
 */
proto.xcommon.ResourcePermInfo.prototype.setPermname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Value = 5;
 * @return {string}
 */
proto.xcommon.ResourcePermInfo.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ResourcePermInfo} returns this
 */
proto.xcommon.ResourcePermInfo.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Operator = 6;
 * @return {string}
 */
proto.xcommon.ResourcePermInfo.prototype.getOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.xcommon.ResourcePermInfo} returns this
 */
proto.xcommon.ResourcePermInfo.prototype.setOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 OperatorTime = 7;
 * @return {number}
 */
proto.xcommon.ResourcePermInfo.prototype.getOperatortime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ResourcePermInfo} returns this
 */
proto.xcommon.ResourcePermInfo.prototype.setOperatortime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 BindingId = 8;
 * @return {number}
 */
proto.xcommon.ResourcePermInfo.prototype.getBindingid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.xcommon.ResourcePermInfo} returns this
 */
proto.xcommon.ResourcePermInfo.prototype.setBindingid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


module.exports = proto.xcommon;
